import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'registrazione',
    pathMatch: 'full'
  },
  
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'list/:page',
    canActivate: [AuthGuard],
    loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
  },
  {
    path: 'list',
    canActivate: [AuthGuard],
    loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
  },
  {
    path: 'ranking',
    canActivate: [AuthGuard],
    loadChildren: () => import('./ranking/ranking.module').then(m => m.RankingPageModule)
  },
  {
    path: 'login/:token',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'registrazione/:token',
    loadChildren: () => import('./registrazione/registrazione.module').then( m => m.RegistrazionePageModule)
  },
  {
    path: 'registrazione',
    loadChildren: () => import('./registrazione/registrazione.module').then( m => m.RegistrazionePageModule)
  },
  {
    path: 'creagara',
    canActivate: [AuthGuard],
    loadChildren: () => import('./creagara/creagara.module').then( m => m.CreagaraPageModule)
  },
  {
    path: 'startgara',
    canActivate: [AuthGuard],
    loadChildren: () => import('./startgara/startgara.module').then( m => m.StartgaraPageModule)
  },
  {
    path: 'dettaglio-gara/:idgara',
    canActivate: [AuthGuard],
    loadChildren: () => import('./dettaglio-gara/dettaglio-gara.module').then( m => m.DettaglioGaraPageModule)
  },
  {
    path: 'creaserie',
    canActivate: [AuthGuard],
    loadChildren: () => import('./creaserie/creaserie.module').then( m => m.CreaseriePageModule)
  },
  {
    path: 'classifica/:idgara',
    canActivate: [AuthGuard],
    loadChildren: () => import('./classifica/classifica.module').then( m => m.ClassificaPageModule)
  },
  {
    path: 'selectuser',
    loadChildren: () => import('./selectuser/selectuser.module').then( m => m.SelectuserPageModule)
  },
  {
    path: 'addtiratore',
    loadChildren: () => import('./addtiratore/addtiratore.module').then( m => m.AddTiratorePageModule)
  },
  {
    path: 'generaslot',
    loadChildren: () => import('./generaslot/generaslot.module').then( m => m.GeneraslotPageModule)
  },
  {
    path: 'login-esterno',
    loadChildren: () => import('./login-esterno/login-esterno.module').then( m => m.LoginEsternoPageModule)
  },
  {
    path: 'giorni',
    canActivate: [AuthGuard],
    loadChildren: () => import('./giorni/giorni.module').then( m => m.GiorniPageModule)
  },
  {
    path: 'preno/:giorno',
    canActivate: [AuthGuard],
    loadChildren: () => import('./preno/preno.module').then( m => m.PrenoPageModule)
  },
  {
    path: 'fixcategoria',
    loadChildren: () => import('./fixcategoria/fixcategoria.module').then( m => m.FixcategoriaPageModule)
  },
  {
    path: 'rankingarchiviati',
    loadChildren: () => import('./rankingarchiviati/rankingarchiviati.module').then( m => m.RankingarchiviatiPageModule)
  },
  {
    path: 'creautenteesterno',
    loadChildren: () => import('./creautenteesterno/creautenteesterno.module').then( m => m.CreautenteesternoPageModule)
  }
  // ,
  // {
  //   path: '**',
  //   redirectTo: 'registrazione/:token',
  //   // pathMatch: 'full'
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true,preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
